import { Header } from "semantic-ui-react";

import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import db from "astrid-firebase/src/db";
import useDocumentDataOnce from "astrid-firestore/src/hooks/useDocumentDataOnce";

import Flex from "../../../../components/Flex/Flex";
import PrimaryButton from "../../../ui/components/Buttons/PrimaryButton";
import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";

import AgreementTemplateCard from "../../components/AgreementTemplateCard/AgreementTemplateCard";
import AgreementsForm from "../../components/AgreementsForm/AgreementsForm";

export default function PrepareAgreementsView({ agreement, templateId, organization }) {
	const { t } = useTranslation();

	const navigate = useNavigate();

	const [template, loading, error] = useDocumentDataOnce(
		templateId && db.collection("agreementTemplates").doc(templateId),
	);

	return (
		<>
			<Flex gap={10} wrap style={{ marginBottom: 15 }}>
				<div>
					<Header as="h2">{t("prepareAgreements", "Prepare agreements")}</Header>
				</div>

				<div style={{ whiteSpace: "nowrap" }}>
					<Flex gap={10} justifyContent="flex-start">
						<PrimaryButton as={Link} to="../templates">
							{t("createFromAgreementTemplate", "Create from agreement template")}
						</PrimaryButton>
					</Flex>
				</div>
			</Flex>

			<LoadingContext data={template || agreement} loading={loading} error={error}>
				{template && <AgreementTemplateCard template={template} />}

				<AgreementsForm
					template={template}
					agreement={agreement}
					organization={organization}
					afterSubmit={() => navigate("../pending")}
				/>
			</LoadingContext>
		</>
	);
}
